import { AvailablePaymentCurrency, formatCurrencyFromCents, IsoLocale } from "@simplyk/common";
import { DateTime } from "luxon";

const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;

const PAYMENT_CURRENCIES: ReadonlySet<string> = new Set(Object.values(AvailablePaymentCurrency));

const isPaymentCurrency = (currency: string): currency is AvailablePaymentCurrency => PAYMENT_CURRENCIES.has(currency);

export const formatToolDate = (value: string, isoLocale: IsoLocale): string => {
  const date = DATE_ONLY.test(value)
    ? DateTime.fromISO(value, { zone: "utc" })
    : DateTime.fromISO(value, { setZone: true });
  return date.isValid ? date.setLocale(isoLocale).toLocaleString(DateTime.DATE_MED) : value;
};

export const formatToolAmount = (amount: number, currency: string, isoLocale: IsoLocale): string => {
  const normalizedCurrency = currency.toLowerCase();
  return isPaymentCurrency(normalizedCurrency)
    ? formatCurrencyFromCents(amount, { isoLocale, currency: normalizedCurrency })
    : `${(amount / 100).toFixed(2)} ${currency.toUpperCase()}`;
};
